import moment, { Moment } from 'moment';
import { stateManager } from '../../../user/stateManager';
import {
  MONTHLY_GOAL_EXPIRY_DAYS,
  MONTHLY_GOAL_REMINDER_DAYS,
  MONTHLY_GOAL_REMINDER_DISMISSED_KEY,
  MONTHLY_GOAL_SURVEY_KEY,
} from '../../MonthlyGoal';

export interface ManageGoalNotification {
  creation_time: Moment;
  persistent: true;
  providerId: number;
  type: 'manage_goal';
  uuid: 'manage-goal-notification';
}

/**
 * Checks to see if the ManageGoalNotification should be shown in notification dropdown
 * @param {number} providerId
 */
export const shouldShowManageGoalNotification = async () => {
  const actionValues = await stateManager.getActionValues(
    MONTHLY_GOAL_REMINDER_DISMISSED_KEY,
    MONTHLY_GOAL_SURVEY_KEY,
  );

  const goal = actionValues[MONTHLY_GOAL_SURVEY_KEY];

  const showSetAGoal = !goal
    || !goal.time
    || moment.utc(goal.time).add('days', MONTHLY_GOAL_EXPIRY_DAYS) < moment.utc();
  const showGoalReminder = goal
    && goal.time
    && moment.utc(goal.time).add('days', MONTHLY_GOAL_REMINDER_DAYS)
    < moment.utc();

  if (showSetAGoal) {
    // Enable notification and prompt to set a goal
    return true;
  }

  if (showGoalReminder) {
    const dismissedDate = actionValues[MONTHLY_GOAL_REMINDER_DISMISSED_KEY];
    const shouldRemind = !dismissedDate || moment.utc(dismissedDate) < moment.utc(goal.time);

    if (shouldRemind) {
      // Enable notification and show reminder if not already dismissed
      return true;
    }
  }

  // Do not show when goal is set or not time for reminders
  return false;
};

/**
 * Creates the ManageGoalNotification
 * @param {number} providerId
 */
export const createManageGoalNotification = (
  providerId: number,
): ManageGoalNotification => ({
  creation_time: moment.utc(),
  persistent: true,
  providerId,
  type: 'manage_goal',
  uuid: 'manage-goal-notification',
});
